/**
 * Theme toggle (port of crates/rm-ui/src/theme.rs). The `dark` class lives on
 * <html> (default on, set in index.html); CSS vars swap via :root.dark.
 */
import { useSyncExternalStore } from 'react'

function htmlHasDark(): boolean {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
  )
}

function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  })
  return () => observer.disconnect()
}

function toggle() {
  document.documentElement.classList.toggle('dark')
}

export function useTheme() {
  const dark = useSyncExternalStore(subscribe, htmlHasDark, () => true)
  return { dark, toggle }
}
